
var PdpBelowFoldDetailsV3InView = "false";

var PdpBelowFoldDetailsV3Images;
var PdpBelowFoldDetailsV3Texts;

function PdpBelowFoldDetailsV3Initialize()
{
  PdpBelowFoldDetailsV3Images =  document.body.querySelectorAll(".pdp-standardProduct-description-main-bgImage");
  PdpBelowFoldDetailsV3Texts =  document.body.querySelectorAll(".pdp-standardProduct-description-main-details");
}

function PdpBelowFoldDetailsV3()
{

  //console.log("PdpBelowFoldDetailsV3");
  if(window.innerWidth < 1100)
  {
    PdpBelowFoldDetailsV3Images.forEach((PdpBelowFoldDetailsV3Image) => {
      PdpBelowFoldDetailsV3Image.style.transform = "translateY(0px)";
    });
    PdpBelowFoldDetailsV3Texts.forEach((PdpBelowFoldDetailsV3Text) => {
      PdpBelowFoldDetailsV3Text.style.transform = "translateY(0px)";
    });
    return;
  }
  
  //class for details pdp-standardProduct-description-main
  var productDetailRectData = document.body.querySelector(".pdp-standardProduct-description-main").getBoundingClientRect();
  //console.log('PdpBelowFoldDetailsV3 scroll productDetailRectData.top = ' + productDetailRectData.top);
  //console.log('PdpBelowFoldDetailsV3Images.length' + PdpBelowFoldDetailsV3Images.length);
  if(Math.abs(productDetailRectData.top) < 500)
  {
    PdpBelowFoldDetailsV3Images.forEach((PdpBelowFoldDetailsV3Image) => {
      PdpBelowFoldDetailsV3Image.style.transform = "translateY(50px)";
    });
    PdpBelowFoldDetailsV3Texts.forEach((PdpBelowFoldDetailsV3Text) => {
      PdpBelowFoldDetailsV3Text.style.transform = "translateY(-50px)";
    });
  }

  /*
  if(Math.abs(productDetailRectData.top) > 700)
  {
    PdpBelowFoldDetailsV3Images.forEach((PdpBelowFoldDetailsV3Image) => {
      PdpBelowFoldDetailsV3Image.style.transform = "translateY(0px)";
    });
    PdpBelowFoldDetailsV3Texts.forEach((PdpBelowFoldDetailsV3Text) => {
      PdpBelowFoldDetailsV3Text.style.transform = "translateY(0px)";
    });
  }
  */
}



addEventListener("DOMContentLoaded", (event) => {
  PdpBelowFoldDetailsV3Initialize();
  window.addEventListener('scroll', PdpBelowFoldDetailsV3);
});